import { render, staticRenderFns } from "./ActivateCompany.vue?vue&type=template&id=0a9b7bb6&scoped=true&"
import script from "./ActivateCompany.vue?vue&type=script&lang=js&"
export * from "./ActivateCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9b7bb6",
  null
  
)

export default component.exports